import { Query } from '@apollo/client/react/components'
import PropTypes from 'prop-types'
import Error from '@components/error'
import LinearProgress from '@material-ui/core/LinearProgress'
import gql from 'graphql-tag'
import WeLoveThisGame from './we-love-this-game'
import weLoveThisGameFragment from './we-love-this-game.fragment'

export const WE_LOVE_THIS_GAME_QUERY = gql`
query WeLoveThisGame($preview: Boolean, $slug: String!) {
  weLoveThisGameCollection(limit: 1, preview: $preview, where: {slug: $slug}) {
    items {
      ${weLoveThisGameFragment}
    }
  }
}
`

function WeLoveThisGameWithData(props) {
  const { slug, ssrData, ...restProps } = props

  // If SSR data is provided, render directly
  if (ssrData !== undefined) {
    return ssrData ? (
      <WeLoveThisGame {...restProps} slug={slug} {...ssrData} />
    ) : <Error statusCode={404} />
  }

  // Fallback to client-side fetching
  return (
    <Query
      query={WE_LOVE_THIS_GAME_QUERY}
      variables={{ slug }}
    >
      {({ loading, error, data }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />

        const response = data?.weLoveThisGameCollection?.items[0]
        return response ? (
          <WeLoveThisGame {...restProps} slug={slug} {...response} />
        ) : <Error statusCode={404} />
      }}
    </Query>
  )
}

WeLoveThisGameWithData.propTypes = {
  slug: PropTypes.string.isRequired,
  ssrData: PropTypes.object,
}
export default WeLoveThisGameWithData
